import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { subscribeDataMutation } from '../../shared/api/dataSync';
import { getInvalidationTargetsForMutation } from '../../shared/api/queryInvalidation';

export default function QueryProvider({ children }) {
  const client = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
    []
  );

  useEffect(() => {
    const unsubscribe = subscribeDataMutation((event) => {
      const queryKeys = getInvalidationTargetsForMutation(event);
      queryKeys.forEach((queryKey) => {
        client.invalidateQueries({ queryKey });
      });
    });

    return unsubscribe;
  }, [client]);

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
